//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { directive } from 'vue-awesome-swiper'
import('swiper/css/swiper.min.css')

export default {
  name: 'ProgrammingFeatures',
  components: {
    Swiper: () => import('vue-awesome-swiper').then((m) => m.Swiper),
    SwiperSlide: () => import('vue-awesome-swiper').then((m) => m.SwiperSlide),
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination',
        },
      },
      isMobileLg: null,
    }
  },
  mounted() {
    this.windowSizeHandler()
    window.addEventListener('resize', this.windowSizeHandler, { passive: true })
  },
  methods: {
    windowSizeHandler() {
      this.isMobileLg = window.innerWidth <= 640
    },
  },
}
